import { body } from '@phi/components';
import './CatastrophicError.scss';
import { h, defineComponent } from 'vue';

export default defineComponent({
    props: {
        message: { required: true, type: String },
    },

    render() {
        return h('div', {
            class: 'catastrophic-error',
        }, body([
            h('h1', 'Oops! Something went horribly wrong!'),
            h('p', this.message),
        ]));
    }
});
